import { FC } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { formatDecimals } from "../../../utils/utils";
import "./InvoiceList.css";

interface InvoicesListProps {
  data: any;    
  componentRef: any;
}

const InvoicesList : FC<InvoicesListProps>= ({ componentRef, data }) => {

  console.log(data.invoices);
  const { currentUser } = useAuth() as any;
  const subtotal = data.invoices.reduce((s:number, x:any) => s + (x.total + x.discount), 0);
  const discount = data.invoices.reduce((s:number, x:any) => s + x.discount, 0);
  const neto = data.invoices.reduce((s:number, x:any) => s + x.total, 0);
  
  const Line = ({ label, value } : any) => (
    <div className="line-row">
      <span className="line-label">{label}</span>
      <span className="line-dots"></span>
      <span className="line-value">{formatDecimals(value)}</span>
    </div>
  );

  return (
    <div className="ticket-2" ref={componentRef}>

      <div className="center">{data?.City}</div>
      <div className="center">{data?.Phone_No ?? data?.Phone_No_2}</div>
      <div className="center">{data?.E_Mail}</div>

      <div className="title">RELACION DE FACTURA</div>

      <div className="divider" />

      <div className="info-row">
        <span className="bold">CAJA #:</span>
        <span>{data.tpv}</span>
        <span className="bold">TURNO #:</span>
        <span>{data.turn}</span>
      </div>

      <div className="info-row">
        <span className="bold">Usuario:</span>
        <span>{currentUser.username}</span>
      </div>

      <div className="info-row">
        <span className="bold">DESDE #:</span>
        <span>{data.invoices?.[0]?.no}</span>
        <span>{data.date}</span>
      </div>

      <div className="info-row">
        <span className="bold">HASTA #:</span>
        <span>{data.invoices?.[data.invoices.length - 1]?.no}</span>
         <span>{data.dateTo}</span>
      </div>

      <div className="table-header">
        <span>FACTURA</span>
        <span className='text-rigth'>SUB-TOTAL</span>
        <span className='text-rigth'>Impuesto</span>
        <span className='text-rigth'>NETO</span>
      </div>

      {data.invoices.map((i:any, k:number) => (
        <div key={k} className="table-row">
          <span>{i.no}</span>
          <span className="num">{formatDecimals(i.total + i.discount)}</span>
          <span className="num">{formatDecimals(0)}</span>
          <span className="num">{formatDecimals(i.total)}</span>
        </div>
      ))}

      <div className="divider" />

      <Line label="SUB-TOTAL:" value={subtotal} />
      <Line label="DESCUENTO:" value={discount} />
      <Line label="Impuesto:" value={0} />
      <Line label="NETO:" value={neto} />

    </div>
  );
};

export default InvoicesList;
